export default __webpack_public_path__ + "static/media/staff.9182ed5b.svg";